import { useState } from "react"

export enum EmoteBgPosition {
    top = 'top',
    bottom = 'bottom',
}

interface IColorEmoteBackground {
    position?: EmoteBgPosition
    heightClass?: string
}

export const ColorEmoteBackground = ({position, heightClass} : IColorEmoteBackground) => {
    const getInitialColors = () => {
        let shade = 50
        let colorsNames = ['violet', 'purple', 'fuchsia', 'pink', 'rose', 'orange', 'amber', 'yellow', 'lime', 'green', 'emerald', 'teal', 'cyan', 'sky', 'blue', 'indigo']
        let colors = []
        colorsNames.forEach(colorName => {
            colors.push(`bg-${colorName}-${shade}`)
        })
        // reverse colors order
        if (position == EmoteBgPosition.top ) colors = colors.reverse()
        return colors
    }
    const [colors, setColors] = useState(getInitialColors())

    const positionCss = position == EmoteBgPosition.top ? '-top-10' : 'bottom-0'

    return (
        <div 
        className={`absolute ${positionCss} -left-[100px] -right-[200px] ${heightClass ? heightClass : "h-1/4"} grid grid-cols-2 gap-0 blur-3xl`}
        //className="absolute -top-10 -left-[100px] -right-[200px] h-1/3 grid grid-cols-2 gap-0 blur-lg  z-10"
        >
            {colors.map((color, index) => (
                <div key={index} className={`${color}`}></div>
            ))}
        </div>
    )
}